import React from 'react';
import { reactGaEvent } from 'examsbook-react-sdk/actions/Common';
import { convertToDate } from "examsbook-react-sdk/common";
import { NavLink, useNavigate } from 'react-router-dom';
import { useTimeRemainingQuiz, useIsPremiumUser, useQuizButtonStatus } from "examsbook-react-sdk/custom-hooks";
import CrownIcon from "../../../assets/images/icons-crown.svg";

/**
 * Release plan for mobile.
 * @param props
 * @returns {*}
 * @constructor
 */
function ReleasePlanMobile(props) {
    const { t, quiz } = props;
    const isPremium = useIsPremiumUser();
    const { action, label } = useQuizButtonStatus(quiz);
    const timeRemaining = useTimeRemainingQuiz(quiz);
    const disabled = true;
    const currentDate = new Date().getTime();
    const navigate = useNavigate();

    function onResultViewClick() {
        reactGaEvent("Test", "Result");
    }

    function gotoPage(location) {
        navigate('/my-app/' + location);
        reactGaEvent("Live Test", "Start Quiz");
    }

    function handleClickAction() {
        if (action === 'PAYMENT') {
            //open payment popup and make payment.
            navigate("/my-app/payments");
        }
    }

    return (
        <ul>
            <span>
            {quiz.pricing === "PAID" && <img src={CrownIcon} alt="crown icon"/>}
            </span>
            <li>
                <span>{t('test')}</span>
                <span className="right">{quiz.name}</span>
            </li>
            <li><span>{t('question')}</span>
                <span className="right">{quiz.total}</span>

            </li>
            <li>
                <span>{t('time_in_minute')}</span>
                <span className="right">{quiz.duration}</span>

            </li>
            <li>
                <span>{t('available_from')}</span>
                <span className="right">
                            <span
                                className={quiz.startDate && quiz.endDate ? quiz.startDate > currentDate ? '' : quiz.endDate > currentDate ?
                                    'green-color' : 'red-color' : 'green-color'}>
                    {quiz.startDate && quiz.endDate ? quiz.startDate > currentDate ? convertToDate(quiz.startDate) : quiz.endDate && quiz.endDate > currentDate ?
                        t('Available') : t('Expired') : t('Available')}
                            </span>
                        </span>
            </li>
            <li>
                <span>{t('available_till')}</span>
                <span className="right">
                            <span
                                className={quiz.endDate ? quiz.endDate > currentDate ? '' : 'red-color' : 'green-color'}>
                        {quiz.endDate ? quiz.endDate > currentDate ? convertToDate(quiz.endDate) : t('Expired') : t('Available')}
                            </span>
                        </span>
            </li>
            <li>
                <span></span>
                <span className="right">
                            {quiz.startDate <= new Date().getTime() || !quiz.startDate ?
                                <span>
                                    {quiz.attempted ?
                                        quiz.progressed ?
                                            //condition to check progressed quiz is not submitted
                                            <div
                                                onClick={() => gotoPage('quiz/' + quiz.mode + '/' + quiz.slug)}>
                                                <button>{t('RESUME_QUIZ')}
                                                </button>
                                            </div> :
                                            //condition to submitted quiz result date
                                            !quiz.resultDate || (quiz.resultDate && quiz.resultDate <= new Date().getTime()) ?
                                                <NavLink to={'/my-app/tests/result/' + quiz._id}>
                                                    <button onClick={onResultViewClick}>
                                                        {t('view_result')}
                                                    </button>
                                                </NavLink> :
                                                <button disabled={disabled}>
                                                    {t('Result_pending')}{timeRemaining}
                                                </button>
                                        : quiz.pricing === "PAID" && !isPremium ?
                                            <button onClick={handleClickAction}>
                                                {label}
                                            </button>
                                            : <div
                                                onClick={() => gotoPage('quiz/' + quiz.mode + '/' + quiz.slug)}>
                                                {!quiz.progressed ?
                                                    <button>{t('start_quiz')}
                                                    </button> : <button>{t('RESUME_QUIZ')}
                                                    </button>
                                                }
                                            </div>
                                    }
                        </span> : timeRemaining ?
                                    <button disabled={disabled}>{t('live_in')}{timeRemaining}</button> : ''
                            }
                        </span>
            </li>

        </ul>
    );
}

export default ReleasePlanMobile;
